export default function About() {
  const testimonials = [
    {
      name: "阿岚",
      role: "资深插画收藏者",
      text: "在这里找到了很多此前难觅的高质量原画与壁纸，分类清晰，画面还原度极高，是我每日必逛的画廊。",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20chinese%20woman%20with%20gentle%20smile%2C%20soft%20natural%20lighting%2C%20warm%20tone%2C%20clean%20simple%20background%2C%20editorial%20style&width=200&height=200&seq=avatar-01&orientation=squarish",
    },
    {
      name: "顾西洲",
      role: "独立画师",
      text: "琉璃神社对画风的梳理非常专业，尤其是国风与工笔专题，给了我很多创作上的灵感与参考。",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20chinese%20man%20with%20glasses%20and%20artistic%20look%2C%20warm%20studio%20lighting%2C%20soft%20background%2C%20editorial%20style&width=200&height=200&seq=avatar-02&orientation=squarish",
    },
    {
      name: "小满",
      role: "ACG 爱好者",
      text: "页面视觉非常沉浸，浏览体验流畅，收藏夹里全是这里的作品，简直就是视觉爱好者的宝库。",
      avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20friendly%20young%20woman%20with%20short%20hair%2C%20natural%20warm%20lighting%2C%20neutral%20background%2C%20editorial%20photography&width=200&height=200&seq=avatar-03&orientation=squarish",
    },
  ];

  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">About Us</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">关于琉璃神社</h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              琉璃神社是一个专注 ACG 视觉美学的画廊鉴赏平台，汇集来自国内外的原画设定、精美插画与多元画风作品。
              我们相信，好的画面拥有直抵人心的力量。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们坚持内容为先，精心甄选每一幅作品，按画风与主题细致分类，帮助每一位同好快速找到心仪的图集与壁纸，
              并在细节处还原作品的笔触与光影。无论你寻找高清壁纸，还是品味艺术细节，这里都是你的视觉驿站。
            </p>
            <div className="mt-7 grid grid-cols-3 gap-3">
              {[
                { icon: "ri-shield-star-line", title: "精选甄别", desc: "编辑人工筛选" },
                { icon: "ri-empathize-line", title: "多元画风", desc: "36 种风格分类" },
                { icon: "ri-community-line", title: "温暖社区", desc: "24w+ 同好" },
              ].map((f) => (
                <div key={f.title} className="rounded-xl border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/10 text-xl text-primary-600">
                    <i className={f.icon}></i>
                  </span>
                  <p className="mt-3 text-sm font-semibold text-foreground-950">{f.title}</p>
                  <p className="mt-1 text-xs text-foreground-500">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20art%20studio%20desk%20with%20sketchbooks%20brushes%20and%20framed%20illustrations%2C%20soft%20window%20light%2C%20cozy%20creative%20atmosphere%2C%20editorial%20photography&width=900&height=700&seq=about-2026&orientation=landscape"
                alt="琉璃神社艺术工作室场景"
                className="h-64 w-full object-cover object-top md:h-80"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-xl border border-background-200 bg-background-50 p-6">
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <img src={t.avatar} alt={`${t.name}的头像`} className="h-10 w-10 rounded-full object-cover" />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}